import React, { useEffect } from "react";
import { SEO } from "../../components/common/SEO";
import { styled, Theme } from "@mui/system";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ReactRouterLink from "../../components/common/ReactRouterLink";

interface NotFoundProps {}

const NotFoundContainer = styled("div")(({ theme }: { theme: Theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0)), url("/fp-hero-bkg2.jpeg")`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundAttachment: "fixed",
  color: "#fff",
  textAlign: "center",
  padding: "20px",
  paddingTop: theme.spacing(4),
  backdropFilter: "blur(8px)",
}));

const OvalButton = styled(Button)({
  marginTop: 4,
  backgroundColor: "#e78758",
  color: "#fff",
  borderRadius: "50px",
  padding: "8px 16px",
  "&:hover": {
    backgroundColor: "#c56a3e",
  },
});

const NotFound: React.FC<NotFoundProps> = () => {
  return (
    <>
      <SEO
        title="404 Not Found • FiddlePiddle • Toys Marketplace"
        description="The page you are looking for does not exist or has been moved or deleted."
        keywordsContent="404 Not Found, toys marketplace, marketplace for toys, fiddlepiddle"
      />
      <NotFoundContainer>
        <Typography
          variant="h1"
          sx={{
            fontSize: "3em",
            marginBottom: "1rem",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
          }}
        >
          404 Not Found
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "1rem",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
          }}
        >
          The page you are looking for does not exist or has been moved or
          deleted.
        </Typography>
        <ReactRouterLink
          to="/"
          linkElement={
            <OvalButton
              variant="contained"
              sx={{ marginTop: 2, lineHeight: "unset" }}
            >
              Browse Toys
            </OvalButton>
          }
        />
      </NotFoundContainer>
    </>
  );
};

export default NotFound;
